/* Shipping Estimator v5 -- loaded once, survives AJAX
   Waehrung (15.09.2026): data-cart-total ist die Praesentationswaehrung des Kunden (USD, CHF, SEK ...).
   ZONES sind EUR (Shop-Waehrung) und werden mit window.Shopify.currency.rate umgerechnet;
   Shopify rundet umgerechnete Betraege auf ganze Einheiten AUF, JPY/HUF auf 100 -- gemessen gegen
   die oeffentliche Storefront-Warenkorb-API (CH 16,90 EUR -> 17 CHF, SE 7,90 -> 91 SEK, JP 49,90 -> 9.200 JPY).
   USA: seit 16.09.2026 Staffel nach Warenwert in EUR (US_TIERS). Shopify vergleicht die Grenzen mit
   Warenkorb in Kundenwaehrung / rate -- gemessen: 4x SR44 = 39,80 EUR, als 48 USD -> Stufe 2 ($51).
   Zahlenformat liefert das Theme selbst (data-money-sample = {{ 123456 | money_with_currency }}),
   damit die Summe genauso aussieht wie die uebrigen Betraege im Warenkorb. */
(function(){
  var ZONES={DE:{s:0},AT:{s:7.90},BE:{s:7.90},BG:{s:7.90},HR:{s:7.90},CY:{s:7.90},CZ:{s:7.90},DK:{s:7.90},EE:{s:7.90},FI:{s:7.90},FR:{s:7.90},GR:{s:7.90},HU:{s:7.90},IE:{s:7.90},IT:{s:7.90},LV:{s:7.90},LT:{s:7.90},LU:{s:7.90},MT:{s:7.90},NL:{s:7.90},PL:{s:7.90},PT:{s:7.90},RO:{s:7.90},SK:{s:7.90},SI:{s:7.90},ES:{s:7.90},SE:{s:7.90},CH:{s:16.90},CA:{s:16.90},NO:{s:16.90},US:{s:36.90},AU:{s:49.90},JP:{s:49.90},NZ:{s:49.90},SG:{s:49.90},HK:{s:49.90},TW:{s:49.90},KR:{s:49.90}};
  var NAMES={DE:{de:'Deutschland',en:'Germany',fr:'Allemagne',es:'Alemania',it:'Germania'},AT:{de:'\u00d6sterreich',en:'Austria',fr:'Autriche',es:'Austria',it:'Austria'},CH:{de:'Schweiz',en:'Switzerland',fr:'Suisse',es:'Suiza',it:'Svizzera'},FR:{de:'Frankreich',en:'France',fr:'France',es:'Francia',it:'Francia'},IT:{de:'Italien',en:'Italy',fr:'Italie',es:'Italia',it:'Italia'},ES:{de:'Spanien',en:'Spain',fr:'Espagne',es:'Espa\u00f1a',it:'Spagna'},NL:{de:'Niederlande',en:'Netherlands',fr:'Pays-Bas',es:'Pa\u00edses Bajos',it:'Paesi Bassi'},US:{de:'USA',en:'USA',fr:'USA',es:'EE.UU.',it:'USA'},BE:{de:'Belgien',en:'Belgium',fr:'Belgique',es:'B\u00e9lgica',it:'Belgio'},PL:{de:'Polen',en:'Poland',fr:'Pologne',es:'Polonia',it:'Polonia'},SE:{de:'Schweden',en:'Sweden',fr:'Su\u00e8de',es:'Suecia',it:'Svezia'},DK:{de:'D\u00e4nemark',en:'Denmark',fr:'Danemark',es:'Dinamarca',it:'Danimarca'},NO:{de:'Norwegen',en:'Norway',fr:'Norv\u00e8ge',es:'Noruega',it:'Norvegia'},CA:{de:'Kanada',en:'Canada',fr:'Canada',es:'Canad\u00e1',it:'Canada'},AU:{de:'Australien',en:'Australia',fr:'Australie',es:'Australia',it:'Australia'},JP:{de:'Japan',en:'Japan',fr:'Japon',es:'Jap\u00f3n',it:'Giappone'},KR:{de:'S\u00fcdkorea',en:'South Korea',fr:'Cor\u00e9e du Sud',es:'Corea del Sur',it:'Corea del Sud'},CZ:{de:'Tschechien',en:'Czech Republic',fr:'Tch\u00e9quie',es:'Chequia',it:'Cechia'},PT:{de:'Portugal',en:'Portugal',fr:'Portugal',es:'Portugal',it:'Portogallo'},FI:{de:'Finnland',en:'Finland',fr:'Finlande',es:'Finlandia',it:'Finlandia'},HU:{de:'Ungarn',en:'Hungary',fr:'Hongrie',es:'Hungr\u00eda',it:'Ungheria'},GR:{de:'Griechenland',en:'Greece',fr:'Gr\u00e8ce',es:'Grecia',it:'Grecia'},IE:{de:'Irland',en:'Ireland',fr:'Irlande',es:'Irlanda',it:'Irlanda'},RO:{de:'Rum\u00e4nien',en:'Romania',fr:'Roumanie',es:'Ruman\u00eda',it:'Romania'},NZ:{de:'Neuseeland',en:'New Zealand',fr:'Nouvelle-Z\u00e9lande',es:'Nueva Zelanda',it:'Nuova Zelanda'},BG:{de:'Bulgarien',en:'Bulgaria',fr:'Bulgarie',es:'Bulgaria',it:'Bulgaria'},HR:{de:'Kroatien',en:'Croatia',fr:'Croatie',es:'Croacia',it:'Croazia'},CY:{de:'Zypern',en:'Cyprus',fr:'Chypre',es:'Chipre',it:'Cipro'},EE:{de:'Estland',en:'Estonia',fr:'Estonie',es:'Estonia',it:'Estonia'},LV:{de:'Lettland',en:'Latvia',fr:'Lettonie',es:'Letonia',it:'Lettonia'},LT:{de:'Litauen',en:'Lithuania',fr:'Lituanie',es:'Lituania',it:'Lituania'},LU:{de:'Luxemburg',en:'Luxembourg',fr:'Luxembourg',es:'Luxemburgo',it:'Lussemburgo'},MT:{de:'Malta',en:'Malta',fr:'Malte',es:'Malta',it:'Malta'},SK:{de:'Slowakei',en:'Slovakia',fr:'Slovaquie',es:'Eslovaquia',it:'Slovacchia'},SI:{de:'Slowenien',en:'Slovenia',fr:'Slov\u00e9nie',es:'Eslovenia',it:'Slovenia'},SG:{de:'Singapur',en:'Singapore',fr:'Singapour',es:'Singapur',it:'Singapore'},HK:{de:'Hongkong',en:'Hong Kong',fr:'Hong Kong',es:'Hong Kong',it:'Hong Kong'},TW:{de:'Taiwan',en:'Taiwan',fr:'Ta\u00efwan',es:'Taiw\u00e1n',it:'Taiwan'}};
  var FREE={de:'Kostenlos',en:'Free',fr:'Gratuit',es:'Gratis',it:'Gratuito'};
  // "Versandkosten" statt "Versand" (23.10.2026, Nutzerblick zu Shop #8493): die Auswahl zeigt nur Kosten, sie stellt das Lieferland nicht ein
  var LABELS={de:'Versandkosten nach',en:'Shipping cost to',fr:'Frais de livraison vers',es:'Gastos de env\u00edo a',it:'Spese di spedizione verso'};
  var INCL={de:'inkl. Versand',en:'incl. shipping',fr:'livr. incl.',es:'env\u00edo incl.',it:'sped. incl.'};
  var DTINC={de:'Zoll & Steuern inklusive',en:'Duties & taxes included',fr:'Droits & taxes inclus',es:'Impuestos incluidos',it:'Dazi e tasse incluse'};
  var TOP5=['DE','US','AT','FR','NL'];
  var EU=['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
  var DTINC_COUNTRIES=EU.concat(['US']);
  // USA-Staffel (Shopify-Versandprofil "Standard DHL USA", Order amount, EUR): Warenwert bis unter Grenze -> Preis.
  var US_TIERS=[[40,36.90],[100,42.90],[200,54.90],[Infinity,64.90]];
  var STEP={JPY:100,HUF:100};
  var LOCALES={de:'de-DE',en:'en-US',fr:'fr-FR',es:'es-ES',it:'it-IT'};

  var lastCountry=null;

  /* Lieferland-Hinweis (23.10.2026, Shop #8493): Die Kasse nimmt das Land, das im Shop eingestellt ist
     (fuer EU-Besucher immer Deutschland), nicht die Auswahl hier. Weicht die Auswahl davon ab, steht darunter
     "Lieferland in der Kasse: Deutschland [Spanien fuer die Kasse uebernehmen]"; der Klick stellt das Land im Shop um
     (Formular localization im Snippet) und laedt den Warenkorb neu (?ak_lf=XX, zaehlbar in GA4), dort steht dann
     eine Bestaetigung und die Seite rollt zum Kassenknopf.
     Mit vollem Warenkorb waehlt das Skript einmal das Land des Besuchers vor, laut Shopify
     (/browsing_context_suggestions.json, dieselbe Abfrage wie der UK-Hinweis), aber nur, wenn es nicht das
     eingestellte Land ist und wir dorthin liefern. Nichts wird gespeichert. Ohne Erkennung (Fehler, 2,5 s)
     bleibt alles wie vorher. LF_AKTIV=false: nur mit ?ak_lieferland=XX in der Adresse (XX = Besucherland zum Testen). */
  var LF_AKTIV=true;
  var LF_TEST=(location.search.match(/[?&]ak_lieferland=([A-Za-z]{2})(?:&|$)/)||[])[1];
  var LF_AN=(LF_AKTIV||!!LF_TEST)&&!(window.Shopify&&window.Shopify.designMode);
  // l = Zustand (Land der Kasse), k = Knopf ({z} = gewaehltes Land; fr/it ohne Namen wegen Artikel), ok = nach dem Umstellen
  var LF_TXT={
    de:{l:'Lieferland in der Kasse:',k:'{z} f\u00fcr die Kasse \u00fcbernehmen',ok:'Lieferland in der Kasse ge\u00e4ndert:'},
    en:{l:'Shipping country at checkout:',k:'Use {z} at checkout',ok:'Shipping country at checkout updated:'},
    fr:{l:'Pays de livraison \u00e0 la caisse\u00a0:',k:'Utiliser ce pays \u00e0 la caisse',ok:'Pays de livraison \u00e0 la caisse modifi\u00e9\u00a0:'},
    es:{l:'Pa\u00eds de env\u00edo al pagar:',k:'Usar {z} al pagar',ok:'Pa\u00eds de env\u00edo al pagar cambiado:'},
    it:{l:'Paese di spedizione alla cassa:',k:'Usa questo paese alla cassa',ok:'Paese di spedizione alla cassa aggiornato:'}
  };
  var LF_EN_THE={NL:1,US:1,CZ:1}; // "Use the Netherlands at checkout"
  // Nach dem Klick kommt der Besucher mit ?ak_lf=XX auf die Warenkorb-Seite: Bestaetigung zeigen, zum Kassenknopf scrollen
  var LF_OK=((location.search.match(/[?&]ak_lf=([A-Za-z]{2})(?:&|$)/)||[])[1]||'').toUpperCase();
  var geo=null,geoLaeuft=false,manuell=false,lfSendet=false,lfGescrollt=false;

  function lfErlaubt(el,code){
    return !!ZONES[code]&&(','+(el.dataset.laender||'')+',').indexOf(','+code+',')>-1;
  }

  // Land des Besuchers einmal je Seite holen; geo: '' = unbekannt.
  function geoHolen(fertig){
    if(geo!==null){fertig();return;}
    if(LF_TEST){geo=LF_TEST.toUpperCase();fertig();return;}
    if(geoLaeuft)return;
    geoLaeuft=true;
    var ctrl=('AbortController' in window)?new AbortController():null;
    // Nach 2,5 s gilt das Land als unbekannt, auch ohne AbortController; eine spaetere Antwort zaehlt nicht mehr.
    var timer=setTimeout(function(){if(geo===null)geo='';if(ctrl)ctrl.abort();},2500);
    fetch('/browsing_context_suggestions.json',ctrl?{credentials:'same-origin',signal:ctrl.signal}:{credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(d){
        clearTimeout(timer);
        if(geo!==null)return;
        geo=String((d&&d.detected_values&&d.detected_values.country&&d.detected_values.country.handle)||'').toUpperCase();
        fertig();
      })
      .catch(function(){clearTimeout(timer);if(geo===null)geo='';});
  }

  // Nur solange der Shop auf Deutschland steht (Vorgabe fuer EU-Besucher): wer selbst ein anderes Land
  // eingestellt hat, bekommt keinen Vorschlag. Das Cookie "localization" setzt Shopify schon beim ersten
  // Besuch (gemessen 23.10.2026), eine eigene Wahl von DE ist daran nicht erkennbar.
  function vorwaehlen(){
    var el=alle()[0];
    if(!el||manuell||lastCountry||!geo)return;
    if((el.dataset.country||'DE')!=='DE'||geo==='DE'||!lfErlaubt(el,geo))return;
    lastCountry=geo;
    syncAll();
  }

  function lfZeile(el,sel,lang){
    var z=el.querySelector('.se-lf');
    var shopLand=el.dataset.country||'DE';
    var ziel=sel.value;
    var form=el.querySelector('form.se-lf-form');
    var bestaetigt=LF_AN&&LF_OK===shopLand&&ziel===shopLand;
    if(!bestaetigt&&(!LF_AN||!form||!ziel||ziel===shopLand||!lfErlaubt(el,ziel))){if(z)z.hidden=true;return;}
    var t=LF_TXT[lang]||LF_TXT.en;
    if(!z){
      z=document.createElement('div');
      z.className='se-lf';
      z.innerHTML='<span class="se-lf__text"><span></span> <strong></strong></span><button type="button" class="se-lf__knopf"></button>';
      z.querySelector('.se-lf__knopf').addEventListener('click',function(){lfUmstellen(el,form,sel.value);});
      var nach=el.querySelector('#se-pddp,.se-pddp')||sel;
      nach.parentNode.insertBefore(z,nach.nextSibling);
    }
    var name=function(c){return (NAMES[c]&&NAMES[c][lang])||(c===shopLand&&el.dataset.countryName)||c;};
    var knopf=z.querySelector('.se-lf__knopf');
    z.querySelector('.se-lf__text span').textContent=bestaetigt?t.ok:t.l;
    z.querySelector('.se-lf__text strong').textContent=name(shopLand);
    if(bestaetigt){
      knopf.hidden=true;
    }else{
      knopf.textContent=t.k.replace('{z}',(lang==='en'&&LF_EN_THE[ziel]?'the ':'')+name(ziel));
      knopf.disabled=lfSendet;
      knopf.hidden=false;
    }
    z.hidden=false;
    if(bestaetigt&&!lfGescrollt&&el.closest('#main-cart-footer')){
      lfGescrollt=true;
      el.scrollIntoView({block:'center'});
    }
  }

  function lfUmstellen(el,form,land){
    if(lfSendet||!lfErlaubt(el,land))return;
    lfSendet=true;
    form.querySelector('[name="country_code"]').value=land;
    var zurueck=form.querySelector('[name="return_to"]');
    if(!zurueck){zurueck=document.createElement('input');zurueck.type='hidden';zurueck.name='return_to';form.appendChild(zurueck);}
    zurueck.value=(el.dataset.cartUrl||'/cart')+'?ak_lf='+land;
    // Seitenleiste und Warenkorb-Seite koennen beide eine Zeile zeigen: alle Knoepfe sperren
    var k=document.querySelectorAll('.se-lf__knopf');
    for(var i=0;i<k.length;i++)k[i].disabled=true;
    form.submit();
  }
  // Zurueck-Taste nach dem Umstellen holt die Seite aus dem Browser-Speicher: Knoepfe wieder freigeben
  window.addEventListener('pageshow',function(e){
    if(!e.persisted||!lfSendet)return;
    lfSendet=false;
    var k=document.querySelectorAll('.se-lf__knopf');
    for(var i=0;i<k.length;i++)k[i].disabled=false;
  });

  // Waehrung, in der der Kunde gerade sieht (Shopify Markets). Ohne Umrechnung: EUR, rate 1.
  function currency(){
    var c=(window.Shopify&&window.Shopify.currency)||{};
    var rate=parseFloat(c.rate);
    return {code:c.active||'EUR',rate:(isFinite(rate)&&rate>0)?rate:1};
  }

  // EUR -> aktive Waehrung, mit Shopifys Aufrundung (ganze Einheit, JPY/HUF 100).
  function convert(eur,cur){
    if(!eur)return 0;
    if(cur.code==='EUR'||cur.rate===1)return eur;
    var step=STEP[cur.code]||1;
    return Math.ceil(eur*cur.rate/step-1e-3)*step;
  }

  // cartTotal in der aktiven Waehrung; die Staffelgrenzen liegen in EUR.
  function shipFor(code,cur,cartTotal){
    var z=ZONES[code];
    if(!z)return null;
    var eur=z.s;
    if(code==='US'){
      var wert=(cartTotal||0)/cur.rate;
      for(var i=0;i<US_TIERS.length;i++){if(wert<US_TIERS[i][0]){eur=US_TIERS[i][1];break;}}
    }
    return convert(eur,cur);
  }

  // Zahlenformat aus einem vom Theme gerenderten Beispiel (1234,56 in der aktiven Waehrung) ableiten.
  function parseSample(sample){
    if(!sample)return null;
    var m=sample.match(/\d[\d.,'\u2019\u00a0\u202f ]*\d/);
    if(!m)return null;
    var num=m[0],digits=num.replace(/\D/g,'');
    if(digits.length<4||digits.length>6)return null;
    var dec=digits.length>=6?2:0;
    var seps=num.replace(/\d/g,'');
    var decSep=dec?num.charAt(num.length-3):'';
    if(dec)seps=seps.slice(0,-1);
    var f={pre:sample.slice(0,m.index),suf:sample.slice(m.index+num.length),dec:dec,decSep:decSep,grp:seps.charAt(0)||''};
    // Selbstpruefung: das abgeleitete Format muss das Beispiel exakt reproduzieren.
    return fmtWith(f,1234.56)===sample?f:null;
  }

  function fmtWith(f,val){
    var s=val.toFixed(f.dec),i=f.dec?s.slice(0,-3):s,rest=f.dec?f.decSep+s.slice(-2):'';
    if(f.grp)i=i.replace(/\B(?=(\d{3})+(?!\d))/g,f.grp);
    return f.pre+i+rest+f.suf;
  }

  // Fallback, falls das Theme kein Beispiel liefert: Locale-Format + Waehrungscode.
  function fallbackFormatter(cur,lang){
    var loc=LOCALES[lang]||'en-US',dec=2;
    try{dec=new Intl.NumberFormat('en',{style:'currency',currency:cur.code}).resolvedOptions().maximumFractionDigits;}catch(e){}
    return function(val){
      var s;
      try{s=val.toLocaleString(loc,{minimumFractionDigits:dec,maximumFractionDigits:dec});}
      catch(e){s=val.toFixed(dec);}
      return s+' '+cur.code;
    };
  }

  function formatter(el,cur,lang){
    var sample=el.dataset.moneySample||'';
    var f=parseSample(sample);
    // Liefert das Theme trotz Fremdwaehrung ein EUR-Beispiel, ist es unbrauchbar.
    if(f&&(cur.code==='EUR'||!/EUR|\u20ac/.test(sample)))return function(val){return fmtWith(f,val);};
    return fallbackFormatter(cur,lang);
  }

  function alle(){return document.querySelectorAll('#shipping-estimator,.shipping-estimator');}

  // Auswahl auf allen Instanzen gleichziehen (Drawer und Warenkorb-Seite stehen gleichzeitig im DOM).
  function syncAll(){
    var list=alle();
    for(var i=0;i<list.length;i++){
      var s=list[i].querySelector('#se-country,.se-country');
      if(s&&lastCountry&&s.value!==lastCountry)s.value=lastCountry;
      if(list[i].__seUpdate)list[i].__seUpdate();
    }
  }

  function init(){
    var list=alle();
    for(var i=0;i<list.length;i++)initOne(list[i]);
  }

  function initOne(el){
    if(!el)return;
    var sel=el.querySelector('#se-country,.se-country');
    var costEl=el.querySelector('#se-cost,.se-cost');
    var lblEl=el.querySelector('#se-label,.se-label');
    if(!sel||!costEl||!lblEl)return;

    var lang=el.dataset.lang||'de';
    if(['de','en','fr','es','it'].indexOf(lang)<0)lang='en';
    var detected=el.dataset.country||'DE';
    var cartCents=parseInt(el.dataset.cartTotal)||0;
    var cartTotal=cartCents/100; // bereits in der aktiven Waehrung
    var cur=currency();
    var fmtPrice=formatter(el,cur,lang);

    // Only populate select if empty (avoid duplicates on AJAX reload)
    if(sel.options.length===0){
      var codes=Object.keys(ZONES);
      // Detected country first, then Top 5 (in order), then rest alphabetically
      codes.sort(function(a,b){
        if(a===detected)return -1;if(b===detected)return 1;
        var ai=TOP5.indexOf(a),bi=TOP5.indexOf(b);
        if(ai>=0&&bi>=0)return ai-bi;
        if(ai>=0)return -1;if(bi>=0)return 1;
        var na=(NAMES[a]&&NAMES[a][lang])||a;
        var nb=(NAMES[b]&&NAMES[b][lang])||b;
        return na.localeCompare(nb);
      });
      codes.forEach(function(c){
        var o=document.createElement('option');
        o.value=c;o.textContent=(NAMES[c]&&NAMES[c][lang])||c;
        if(c===(lastCountry||detected))o.selected=true;
        sel.appendChild(o);
      });
      sel.addEventListener('change',function(){manuell=true;lastCountry=sel.value;syncAll();});
    }

    function update(){
      var shipping=shipFor(sel.value,cur,cartTotal);
      if(shipping===null)return;
      lblEl.textContent=LABELS[lang]||LABELS.en;
      if(shipping===0){
        costEl.textContent=FREE[lang]||FREE.en;
        costEl.style.color='#2e7d32';
      }else{
        costEl.textContent=fmtPrice(shipping);
        costEl.style.color='';
      }
      // Duties & taxes note for EU + US
      var noteEl=el.querySelector('#se-pddp,.se-pddp');
      if(!noteEl){
        noteEl=document.createElement('div');
        noteEl.className='se-pddp';
        noteEl.style.cssText='font-size:1.2rem;color:rgba(var(--color-foreground),.55);margin-top:4px;font-family:var(--font-body-family,"Jost",sans-serif);';
        sel.parentNode.insertBefore(noteEl,sel.nextSibling);
      }
      var showNote=DTINC_COUNTRIES.indexOf(sel.value)>=0;
      noteEl.textContent=showNote?(DTINC[lang]||DTINC.en):'';
      noteEl.style.display=showNote?'block':'none';
      lfZeile(el,sel,lang);
      // Update totals to include shipping (gleiche Waehrung wie der Warenkorb)
      var totalEl=el.closest('.cart-drawer__footer,.cart__footer,#main-cart-footer')?.querySelector('.totals__total-value');
      if(totalEl&&cartTotal>0){
        totalEl.textContent=fmtPrice(cartTotal+shipping);
      }
      // Update totals label to indicate shipping included
      var totalLabel=el.closest('.cart-drawer__footer,.cart__footer,#main-cart-footer')?.querySelector('.totals__total');
      if(totalLabel){
        var t={de:'Gesamt ('+INCL[lang]+')',en:'Total ('+INCL[lang]+')',fr:'Total ('+INCL[lang]+')',es:'Total ('+INCL[lang]+')',it:'Totale ('+INCL[lang]+')'};
        totalLabel.textContent=t[lang]||t.en;
      }
    }
    el.__seUpdate=update;
    update();
    if(LF_AN&&cartCents>0)geoHolen(vorwaehlen);
  }

  // Run on page load
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}

  // Re-run after cart drawer AJAX updates (MutationObserver)
  var observer=new MutationObserver(function(mutations){
    for(var m of mutations){
      if(m.addedNodes.length){
        for(var n of m.addedNodes){
          if(n.nodeType===1&&(n.id==='shipping-estimator'||n.querySelector&&n.querySelector('#shipping-estimator'))){
            setTimeout(init,50);
            return;
          }
        }
      }
    }
  });
  observer.observe(document.body,{childList:true,subtree:true});
})();
